type CardContentProps = {
  title: string;
  content: React.ReactNode;
};

export const CardContent = (props: CardContentProps) => {
  return (
    <div className="bg-white shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 px-4 py-4 rounded-2xl w-full">
      <span className="text-lg font-bold">{props.title}</span>
      <div className="mt-3">{props.content}</div>
    </div>
  );
};
